'use client'

import { getSessionId } from '@entities/authentication'
import { getRedirectUrl, notifyUnauthorized } from '@features/auth'
import { getTypedDestinationParams, setDestinationParams } from '@features/redirect'
import { Destination, GatewaySearchParams } from '@server/schemas'
import { useRouter } from 'next/navigation'
import { useCallback } from 'react'

export const useAuthRedirect = (
  destination: Destination,
  additionalParams?: Omit<GatewaySearchParams, 'destination'>,
) => {
  const router = useRouter()

  return useCallback(async () => {
    try {
      const sessionId = await getSessionId()

      const restoredParams = await getTypedDestinationParams(destination, sessionId)

      if (!restoredParams && additionalParams) {
        await setDestinationParams(destination, sessionId, additionalParams)
      }

      const { url } = await getRedirectUrl(destination)

      try {
        const urlObj = new URL(url)
        router.replace(urlObj.pathname + urlObj.search)
      } catch {
        window.location.href = url
      }
    } catch {
      await notifyUnauthorized()

      router.replace(`/login?destination=${destination}`)
    }
  }, [additionalParams, destination, router])
}
